import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { ApiMasters } from "apihandlers//masters/masters";
import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";

const ApiMastersHandler = new ApiMasters();

const Asset = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [vehicles, setVehicles] = useState();
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const vehicleRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getVehicles();
    }
  }, [loading]);

  const getVehicles = () => {
    const args = {
      activeStatus: true,
      shortMode: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.vehicleNumber,
          };
        });
        setVehicles(list);
        getRows();
      }
    });
  };
  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiMastersHandler.getAssets(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          list[i]["locationStatusText"] = list[i]["locationStatus"]
            ? "Yes"
            : "No";
          list[i]["verifiedText"] = list[i]["verified"] ? "Yes" : "No";
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getUserTypes:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "assetName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ASSET_NAME,
      width: "20%",
    },
    {
      key: "assetType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ASSET_TYPE,
      width: "15%",
    },
    {
      key: "purchasedFrom",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PURCHASED_FROM,
      width: "15%",
    },
    {
      key: "purchaseDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PURCHASE_DATE,
      width: "15%",
    },
    {
      key: "vehicleNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NAME,
      width: "15%",
    },

    {
      key: "activeStatus",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "10%",
    },

    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageAsset = () => {
    const assetName = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();
    const purchasedFrom = (
      document.getElementById("purchasedFrom") as HTMLInputElement
    ).value.trim();
    const purchaseDate = (
      document.getElementById("purchaseDate") as HTMLInputElement
    ).value.trim();
    const vehicleId = vehicleRef.current.selectedValue.id;
    const serial = (
      document.getElementById("serialNo") as HTMLInputElement
    ).value.trim();
    const quantity = (
      document.getElementById("quantity") as HTMLInputElement
    ).value.trim();
    let op = document.querySelector(
      'input[name="assetTypes"]:checked'
    ) as HTMLInputElement;
    const assetType = op ? op.value : "";

    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";

    // Validations
    // if (!assetName) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }

    // if (!purchasedFrom) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!purchaseDate) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!quantity) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!assetType) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }

    let errors = [];
    if (assetName == "") {
      errors.push({
        id: "name",
        msg:
          "<span class='bold'>" +
          LABELS.NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (purchasedFrom == "") {
      errors.push({
        id: "purchasedFrom",
        msg:
          "<span class='bold'>" +
          LABELS.PURCHASED_FROM +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (purchaseDate == "") {
      errors.push({
        id: "purchaseDate",
        msg:
          "<span class='bold'>" +
          LABELS.DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!vehicleId) {
      errors.push({
        id: "vehicleId",
        msg:
          "<span class='bold'>" +
          LABELS.SELECT_VEHICLES +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (serial == "") {
      errors.push({
        id: "serialNo",
        msg:
          "<span class='bold'>" +
          LABELS.SERIAL_NUMBER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (quantity == "") {
      errors.push({
        id: "quantity",
        msg:
          "<span class='bold'>" +
          LABELS.QUANTITY +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      assetName,
      serial,
      quantity,
      purchaseDate,
      purchasedFrom,
      assetType,
      activeStatus,
      vehicleId,
    };
    setIsSubmit(true);
    console.log("manageAsset: args:", args);
    ApiMastersHandler.manageAsset(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.ASSET}</li>
        </ul>
        <h4>{TITLES.ASSET}</h4>
        <p className="SubTitles">{SUB_TITLES.ASSET}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.ASSET}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.ASSET}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.ASSET + ": " + selectedRow.assetName
              : "Add New " + TITLES.ASSET
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <TxtRow
              label={LABELS.NAME}
              id={"name"}
              defaultValue={selectedRow.assetName}
              disabled={isSubmit}
              required={true}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"purchasedFrom"}
              label={LABELS.PURCHASED_FROM}
              defaultValue={selectedRow.purchasedFrom}
              disabled={isSubmit}
              required={true}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"purchaseDate"}
              label={LABELS.DATE}
              disabled={isSubmit}
              type="date"
              required={true}
              defaultValue={
                selectedRow.purchaseDate
                  ? DateFunctions.getFormatedDate(
                      selectedRow.purchaseDate,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE_ONLY
                    )
                  : DateFunctions.getDate(
                      "today",
                      "from",
                      FORMATS.SQL_DATE_ONLY
                    )
              }
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.SELECT_VEHICLES}
              {<span className="red">{" *"}</span>}
            </label>
            <AutoComplete
              list={vehicles}
              childRef={vehicleRef}
              defaultValue={
                selectedRow.vehicleId
                  ? {
                      id: selectedRow.vehicleId,
                      label: selectedRow.vehicleNumber,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"serialNo"}
              label={LABELS.SERIAL_NUMBER}
              defaultValue={selectedRow.serial}
              disabled={isSubmit}
              required={true}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"quantity"}
              label={LABELS.QUANTITY}
              defaultValue={
                selectedRow.id
                  ? Number(selectedRow.quantity).toString()
                  : selectedRow.quantity
              }
              disabled={isSubmit}
              required={true}
              type={"number"}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.ASSET_TYPE}</label>
            <RadioBtn
              name={"assetTypes"}
              row={true}
              disabled={isSubmit}
              list={[
                {
                  id: "0",
                  label: LABELS.TYRE,
                  value: LABELS.TYRE,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "TYRE"
                    : true,
                  disabled: false,
                },
                {
                  id: "1",
                  label: LABELS.ENGINE_OIL,
                  value: LABELS.ENGINE_OIL,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "ENGINE OIL"
                    : false,
                  disabled: false,
                },
                {
                  id: "2",
                  label: LABELS.FILTERS,
                  value: LABELS.FILTERS,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "FILTERS"
                    : false,
                  disabled: false,
                },
                {
                  id: "3",
                  label: LABELS.BELT,
                  value: LABELS.BELT,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "BELT"
                    : false,
                  disabled: false,
                },
                {
                  id: "4",
                  label: LABELS.BEARING,
                  value: LABELS.BEARING,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "BEARING"
                    : false,
                  disabled: false,
                },
                {
                  id: "5",
                  label: LABELS.ELECTRICAL,
                  value: LABELS.ELECTRICAL,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "ELECTRICAL"
                    : false,
                  disabled: false,
                },
                {
                  id: "6",
                  label: LABELS.HOSES,
                  value: LABELS.HOSES,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "HOSES"
                    : false,
                  disabled: false,
                },
                {
                  id: "7",
                  label: LABELS.FASTENERS,
                  value: LABELS.FASTENERS,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "FASTENERS"
                    : false,
                  disabled: false,
                },
                {
                  id: "8",
                  label: LABELS.TOOLS,
                  value: LABELS.TOOLS,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "TOOLS"
                    : false,
                  disabled: false,
                },
                {
                  id: "9",
                  label: LABELS.OTHERS,
                  value: LABELS.OTHERS,
                  checked: selectedRow.id
                    ? selectedRow.assetType === "OTHERS"
                    : false,
                  disabled: false,
                },
              ]}
            />
          </div>

          <div className="formGroup">
            <label>{LABELS.ACTIVE + " " + LABELS.STATUS}</label>
            <RadioBtn
              list={[
                {
                  id: "activeYes",
                  value: "Yes",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === "Yes"
                    : true,
                  disabled: false,
                },
                {
                  id: "activeNo",
                  value: "No",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === "No"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                // loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageAsset}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Asset);
